module.exports = __webpack_public_path__ + "static/img/fjjg.dfde36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/fjjg.png
// module id = SIRt
// module chunks = 1